export enum TasksApiTag {
  task = "task",
  taskAttachments = "taskAttachments",
  taskActivity = "taskActivity",
  taskFields = "taskFields",
  board = "board",
  subtask = "subtask",
  subtaskAttachments = "subtaskAttachments",
  timeLog = "timeLog",
  activeTimeLog = "activeTimeLog",
  myTimeLogsSummary = "myTimeLogsSummary",
}
